import React from 'react';

// A poster-first video for media that sits below the fold. Keeping the source
// out of the DOM is stronger than preload="none": mobile browsers cannot ask
// for MP4 metadata (or opportunistically buffer it) until the visitor taps.
const DeferredVideo = ({ src, poster, ariaLabel = 'Play video' }) => {
  const [started, setStarted] = React.useState(false);

  if (started) {
    return (
      <video
        src={src}
        poster={poster}
        aria-label={ariaLabel}
        className="w-full"
        style={{ borderRadius: '14px', display: 'block', width: '100%', aspectRatio: '480 / 854', objectFit: 'cover' }}
        controls
        playsInline
        autoPlay
        preload="metadata"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setStarted(true)}
      aria-label={ariaLabel}
      style={{
        position: 'relative', display: 'block', width: '100%', padding: 0,
        border: 0, borderRadius: '14px', overflow: 'hidden', cursor: 'pointer',
        background: '#0a2540', aspectRatio: '480 / 854',
      }}
    >
      <img
        src={poster}
        alt=""
        width="480"
        height="854"
        loading="lazy"
        decoding="async"
        style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <span
        aria-hidden="true"
        style={{
          position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
          width: 58, height: 58, borderRadius: '50%', display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: '#fff', background: 'rgba(10,37,64,0.82)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.28)', backdropFilter: 'blur(4px)',
        }}
      >
        <i className="fa-solid fa-play" style={{ fontSize: '1rem', marginLeft: 3 }}></i>
      </span>
    </button>
  );
};

export default DeferredVideo;
